<ion-header>
    <ion-toolbar color="secondary">
        <ion-title>Tows</ion-title>
        <ion-buttons slot="end">
            <ion-button id="tows-sort">
                <i class="material-symbols-outlined">sort</i>
            </ion-button>
            <ion-popover trigger="tows-sort" [dismissOnSelect]="true">
                <ng-template>
                    <ion-content>
                        <ion-list class="tows-sort">
                            <ion-item *ngFor="let sort of towsSortOptions; let last = last" [button]="true"
                                [class.active]="towsSort === sort" [lines]="last ? 'none' : 'full'"
                                (click)="onTowsSort(sort)">
                                <ion-label>{{ sort.name }}</ion-label>
                            </ion-item>
                        </ion-list>
                    </ion-content>
                </ng-template>
            </ion-popover>
            <ion-button (click)="onClose()">
                <i class="material-symbols-outlined">close</i>
            </ion-button>
        </ion-buttons>
    </ion-toolbar>
</ion-header>
<ion-content fullscreen>
    <ion-list>
        <ion-item *ngFor="let towDetails of tows$ | async">
            <ion-label>
                <app-driver-map-tow-details [towDetails]="towDetails" [showToggle]="false" (viewTowDetails)="onViewTowDetails($event)"
                    (cancelTowRequest)="onCancelTowRequest($event)"></app-driver-map-tow-details>
            </ion-label>
        </ion-item>
    </ion-list>
</ion-content>
